import { ref } from "vue";

const currentStep = ref(1);
const highestStep = ref(1);
const totalSteps = ref(4);

export function useStepIndicator() {
  const setStep = (step: number) => {
    currentStep.value = step;
  };

  const setHighestStep = (step: number, options: string ='') => {
    
    if (options === 'override') {
      highestStep.value = step;
    }
    
    else if (step > highestStep.value) {
      highestStep.value = step;
    }
  };

  const setTotalSteps = (steps: number) => {
    totalSteps.value = steps;
  };

  return {
    currentStep,
    highestStep,
    totalSteps,
    setStep,
    setHighestStep,
    setTotalSteps,
  };
}
